import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ReportSelectionPage } from './report-selection';

@NgModule({
  declarations: [
    ReportSelectionPage,
  ],
  imports: [
    IonicPageModule.forChild(ReportSelectionPage),
  ],
})
export class ReportSelectionPageModule {}



// WEBPACK FOOTER //
// ./src/pages/report-selection/report-selection.module.ts